module.exports = __webpack_public_path__ + "img/content6-13.b9b08e54.webp";